export default {
  header: 'Order Summary',
  buttons: {
    checkout: 'Secure checkout',
    continue: 'Continue',
    add_products: '+ Add products',
    add_items: '+ Add more items',
    menu: 'Menu',
  },
  empty_order_basket: {
    description: 'Your basket is empty <br/> Add items to get started',
  },
  promo_code_banner: {
    single_use: '{{discount}} discount - {{code}}',
    multi_use: '{{discount}} discount on {{count}} orders - {{code}}',
    redeem: 'REDEEM',
    redeemed: 'REDEEMED',
  },
  upsell: {
    title: 'People also order',
  },
  rewards: {
    title: 'Pay with points',
    description: '<highlight>Sign in</highlight> to pay with points',
  },
  already_member: 'Already a member?',
  sign_in: 'Sign in',
  summary: {
    subtotal: 'Subtotal',
    delivery: 'Delivery',
    pickup: 'Pickup',
    total: 'Total',
    free: 'Free',
  },
  footer: {
    member_earning: '+{{points}} pts after checkout · {{balance}} pts balance',
    guest_earning: 'Sign up to start earning on this order',
  },
};
